<template>
	<div>
		<!-- {{date1}} -->
		<div class="row align-items-center">
			<div class="col-auto">
				<div style="width: 200px;">
					<b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1"
					class="mb-0" today-button close-button locale="zh"></b-form-datepicker>
				</div>
			</div>
			<div class="col-auto">
				<b-form-checkbox v-model="showReason" switch size="sm" class="mb-0">涨停原因</b-form-checkbox>
			</div>
			<div class="col-auto d-md-none">
				<b-form-checkbox v-model="showMinChart" switch size="sm" class="mb-0">分时</b-form-checkbox>
			</div>
		</div>

		<div class="row alert-primary border d-none d-md-flex">
			<div class="col col-p-0 uplimit_reason_title">名称</div>
			<div class="col col-p-0 uplimit_reason_title">代码</div>
			<div class="col col-p-0 uplimit_reason_title">时间</div>
			<div class="col col-p-0 uplimit_reason_title">板高</div>
			<div class="col col-p-0 uplimit_reason_title">封单额</div>
			<div class="col col-p-0 uplimit_reason_title">成交额</div>
			<div class="col col-p-0 uplimit_reason_title">实流通</div>
			<div class="col col-p-0 uplimit_reason_title">实换手</div>
			<div class="col col-p-0 uplimit_reason_title">题材</div>
		</div>

		<!-- Mobile Navigation Bar -->
		<div class="d-md-none mobile-nav-bar border-bottom mb-2" v-if="uplimit_reason && uplimit_reason.length" ref="mobileNavBar">
			<div class="mobile-nav-item" 
				:class="{active: idx===activePlateIdx}" 
				v-for="(plate, idx) in uplimit_reason" 
				:key="'mob-nav-' + idx" 
				ref="mobileNavItems"
				@click="scrollToPlate(idx)">
				{{plate.plate_name}} <small>({{plate.stocks.length}})</small>
			</div>
		</div>

		<!-- Mobile Header -->
		<div class="row alert-primary border d-flex d-md-none text-center small font-weight-bold" style="font-size: 12px;">
			<div class="col-3 p-1 border-right">股票</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">时间</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">封单</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">成交</div>
			<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">换手</div>
			<div class="col p-1">题材</div>
		</div>

		<div v-if="loading" class="d-flex align-items-center p-2">
			<b-spinner small class="mr-2"></b-spinner>
			<span>载入中...</span>
		</div>

        <div v-bind:key="plate.plate_name + ':' + idx" v-for="(plate, idx) in uplimit_reason">
            <div class="row alert-danger border align-items-center plate-header" :id="'plate-' + idx">
                <span class="uplimit_reason_plate">{{plate['plate_name']}} </span>
                <span class="badge badge-pill badge-danger ur-badge">{{plate['stocks'].length}}</span>
                <span class="uplimit_reason_plate">个</span>
            </div>
			<!-- <div class="row"> -->
                <div class="row border uplimit_reason_row" v-bind:key="stocks.stock_code" v-for="stocks in sortedStocks(plate)">
					<div class="col p-0">
						<!-- Desktop View -->
						<div class="d-none d-md-block">
							<div class="row uplimit_reason m-0">
								<div class="col border col-p-0 uplimit_reason-item">
									<div>{{stocks['stock_name']}}<span v-if="stocks['market_type'].length>0" class="badge badge-pill badge-danger ur-badge">{{stocks['market_type'].substring(0,1)}}</span></div>
								</div>
								<div class="col border col-p-0 uplimit_reason-item">
									<div v-b-toggle.sidebar-right-stock @click="show_sidebar(stocks)" class="cursor-pointer">{{stocks['stock_code']}}</div>
								</div>
								<div class="col border col-p-0 uplimit_reason-item">{{stocks['up_limit_time']}}</div>
								<div v-if="stocks['up_limit_keep_times']>=3" class="col border col-p-0 text-danger uplimit_reason-item">{{stocks['up_limit_desc']}}</div>
								<div v-else-if="stocks['up_limit_keep_times']>1" class="col border col-p-0 text-primary uplimit_reason-item">{{stocks['up_limit_desc']}}</div>
								<div v-else class="col border col-p-0 uplimit_reason-item">{{stocks['up_limit_desc']}}</div>
								
								<div class="col border col-p-0 uplimit_reason-item">{{new Number(stocks['fengdan_money'] / 100000000).toFixed(2)}}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{new Number(stocks['amount']).toFixed(2)}}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{new Number(stocks['actualcirculation_value'] / 100000000).toFixed(2)}}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{ amount_display(stocks) }}</div>
								<div class="col border col-p-0 uplimit_reason-item">{{ theme(stocks) }}</div>
							</div>
							<div class="row text-secondary m-0" v-if="showReason">
								<div class="col border col-p-0 uplimit_reason_text">{{stocks['reason']}}</div>
							</div>
						</div>

						<!-- Mobile View -->
						<div class="d-md-none d-flex border-bottom align-items-center text-center small mobile-stock-row" @click="show_sidebar(stocks)" v-b-toggle.sidebar-right-stock style="font-size: 12px;">
							<!-- 股票 -->
							<div class="col-3 p-1 border-right text-left d-flex flex-column justify-content-center" style="min-height: 40px;">
								<div class="font-weight-bold text-truncate">{{stocks['stock_name']}}<span v-if="stocks['market_type'] && stocks['market_type'].length>0" class="stock-market-tag">{{stocks['market_type'].substring(0,1)}}</span></div>
								<div class="text-muted d-flex align-items-center" style="font-size: 10px;">
									<span>{{stocks['stock_code']}}</span>
									<span v-if="stocks['up_limit_keep_times']>=3" class="badge badge-danger ml-1 p-0 px-1 scale-8">{{stocks['up_limit_desc']}}</span>
									<span v-else-if="stocks['up_limit_keep_times']>1" class="badge badge-primary ml-1 p-0 px-1 scale-8">{{stocks['up_limit_desc']}}</span>
									<span v-else class="badge badge-secondary ml-1 p-0 px-1 scale-8 first-board-badge">{{stocks['up_limit_desc']}}</span>
								</div>
							</div>
							<!-- 时间 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{stocks['up_limit_time']}}
							</div>
							<!-- 封单 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{new Number(stocks['fengdan_money'] / 100000000).toFixed(2)}}
							</div>
							<!-- 成交 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{new Number(stocks['amount']).toFixed(2)}}
							</div>
							<!-- 换手 -->
							<div class="col-1 p-1 border-right" style="flex: 0 0 12.5%; max-width: 12.5%;">
								{{ amount_display(stocks) }}%
							</div>
							<!-- 题材 -->
							<div class="col p-1 text-left" style="line-height: 1.2;">
								<div class="text-truncate-2">{{ theme(stocks) }}</div>
							</div>
						</div>
						<div v-if="showReason" class="d-md-none p-2 border-bottom small text-left text-secondary" style="font-size: 11px; background-color: #f8f9fa;">
							{{stocks['reason']}}
						</div>
						<div v-if="showMinChart" class="d-md-none mobile-min-chart-placeholder border-bottom" :data-stock-code="stocks.stock_code" style="min-height: 100px;">
							<stock-mini-trend 
								v-if="visibleStocks[stocks.stock_code]" 
								:symbol_code="stocks.stock_code" 
								:selected_date="date1"
								chart_heigh="100px"
							></stock-mini-trend>
							<div v-else class="d-flex justify-content-center align-items-center" style="height: 100px; background: #f8f9fa;">
								<span class="text-muted small">载入中...</span>
							</div>
						</div>
					</div>
				</div>
			<!-- </div> -->
			
        </div>
        <div v-if="uplimit_reason && uplimit_reason.length" class="right-axis">
            <div class="axis-item" :class="{ active: idx===activePlateIdx }" v-for="(plate, idx) in uplimit_reason" :key="'axis-' + idx" @click="scrollToPlate(idx)">
                <span class="dot"></span>
                <span class="axis-name">{{ plate.plate_name }}</span>
                <span class="axis-count">{{ (plate.stocks||[]).length }}</span>
            </div>
        </div>
        </div>
</template>

<script>
	import {
		request_zzquant,
		request_zrx
	} from "network/request.js"
	import StockMiniTrend from "../stock/StockMiniTrend"

	export default {
		props: {
			// status_market:{type:Number,default:0}	
		},
		components: {
			// BootstrapTable
			StockMiniTrend
		},
		mounted() {
			request_zrx({
				url: '/open/tradedays'
			}).then(
				res => {
					let days = res['data']['data']
					this.date1 = days[days.length - 1];
				}
			);
			this._onScroll = () => { this.updateActiveByScroll() }
			window.addEventListener('scroll', this._onScroll)
			if(this.showMinChart) {
				this.$nextTick(this.initObserver)
			}
		},
		beforeDestroy(){ 
			if(this._onScroll){ window.removeEventListener('scroll', this._onScroll) }
			if(this.observer){ this.observer.disconnect() }
		},
		watch: {
			// status_market:this.update_info
			activePlateIdx(val) {
				this.scrollNavToView(val);
			},
			showMinChart(val) {
				if(val) {
					this.$nextTick(this.initObserver)
				} else {
					if(this.observer) {
						this.observer.disconnect()
						this.observer = null
					}
					this.visibleStocks = {}
				}
			},
			uplimit_reason() {
				if(this.showMinChart) {
					this.$nextTick(this.initObserver)
				}
			}
		},
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
			return {
				date1: today,
				uplimit_reason: [],
				showReason: false,
				showMinChart: false,
				loading: false,
				activePlateIdx: 0,
				visibleStocks: {},
				observer: null
			}
		},
        methods: {
            initObserver() {
				if (this.observer) {
					this.observer.disconnect();
				}
				this.observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							const stockCode = entry.target.dataset.stockCode;
							if (stockCode && !this.visibleStocks[stockCode]) {
								this.$set(this.visibleStocks, stockCode, true);
								this.observer.unobserve(entry.target);
							}
						}
					});
				}, {
					rootMargin: '100px'
				});
				this.observeStockRows();
			},
			observeStockRows() {
				if (!this.observer) return;
				const elements = this.$el.querySelectorAll('.mobile-min-chart-placeholder');
				elements.forEach(el => {
					if (!this.visibleStocks[el.dataset.stockCode]) {
						this.observer.observe(el);
					}
				});
			},
            onDatePicked(ctx) {
                this.date1 = ctx.selectedYMD;
                // console.log(this.date1);
                this.update_info(this.date1);
            },
			show_sidebar(stock_info){
				this.$emit('show_sidebar',stock_info)
			},
			scrollNavToView(idx) {
				try {
					const navBar = this.$refs.mobileNavBar;
					const items = this.$refs.mobileNavItems;
					
					if (!navBar || !items || !items[idx]) return;
					
					const item = items[idx];
					const itemCenter = item.offsetLeft + item.offsetWidth / 2;
					const containerCenter = navBar.offsetWidth / 2;
					
					let scrollLeft = itemCenter - containerCenter;
					
					navBar.scrollTo({
						left: scrollLeft,
						behavior: 'smooth'
					});
				} catch (e) {
					/* ignore */
				}
			},
			scrollToPlate(idx){
				try{
					const el = document.getElementById('plate-' + idx)
					if(el){ el.scrollIntoView({ behavior: 'smooth', block: 'start' }); this.activePlateIdx = idx }
				}catch(e){ /* ignore */ }
			},
			updateActiveByScroll(){
				try{
					const y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
					let idx = 0
					for(let i=0;i<(this.uplimit_reason||[]).length;i++){
						const el = document.getElementById('plate-' + i)
						if(!el) continue
						const top = el.getBoundingClientRect().top + y
						if(top <= y + 120){ idx = i } else { break }
					}
					this.activePlateIdx = idx
				}catch(e){ /* ignore */ }
			},
            amount_display(stocks){
                let rate = Number(stocks && stocks['turnover_ration_real']);
                if(isNaN(rate) || rate===0){ rate = Number((stocks && (stocks['turnover_ration']||stocks['turnover_rate'])) || 0) }
                if(isNaN(rate) || rate===0) return '';
                if(rate<=1) rate = rate*100;
                return new Number(rate).toFixed(2);
            },
			sortedStocks(plate){
				const list = Array.isArray(plate && plate['stocks']) ? plate['stocks'].slice() : [];
				list.sort((a,b)=>{
					const ka = Number(a && a['up_limit_keep_times']) || 0;
					const kb = Number(b && b['up_limit_keep_times']) || 0;
					if(ka!==kb){ return kb - ka }
					const taMin = this.timeToMinutes(a && a['up_limit_time']);
					const tbMin = this.timeToMinutes(b && b['up_limit_time']);
					if(taMin!==tbMin){ return taMin - tbMin }
					const ta = this.theme(a) || '';
					const tb = this.theme(b) || '';
					return ta.localeCompare(tb);
				});
				return list;
			},
			timeToMinutes(t){
				if(!t) return 0;
				const parts = String(t).split(':');
				const h = parseInt(parts[0]||'0',10);
				const m = parseInt(parts[1]||'0',10);
				if(isNaN(h)||isNaN(m)) return 0;
				return h*60+m;
			},
			theme(stocks){
				const txt = String(stocks && stocks['reason'] || '').trim();
				if(!txt) return '';
				const i1 = txt.indexOf('；');
				const i2 = txt.indexOf(';');
				let idx = i1>=0 ? i1 : (i2>=0 ? i2 : -1);
				if(idx>=0) return txt.substring(0, idx);
				return txt;
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()

				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if (weekday === 0 || weekday === 6) {
					return true;
				}
				//今天之后不能选
				if (time >= now_time) {
					return true;
				}
				return false
			},
			update_info(date1) {
				this.loading = true
				request_zzquant({
					url: 'v2/api/review/uplimit/reason?date1=' + date1,
				}).then(res => {
					this.uplimit_reason = res['data']['data']
					this.loading = false
				}).catch(() => { this.loading = false })
			}
		},

	}
</script>

<style>

.uplimit_reason_row{ border-width:0 0 1px 0 !important; }
.uplimit_reason .uplimit_reason-item{ border-top:0 !important; border-bottom:0 !important; }
.uplimit_reason_text{ border-bottom:0 !important; }
.ur-badge{ font-size:12px; height:18px; padding:0 6px; margin:0 6px; line-height:18px; display:inline-flex; align-items:center; justify-content:center; vertical-align:middle; position:relative; top:4px; background-color:transparent !important; border:1px solid #dc3545; color:#dc3545; }
.uplimit_reason_plate{ display:inline-flex; align-items:center; line-height:18px; }
.plate-header{ min-height:22px; }

/* 调整通用标记位置与大小 */
.ur-badge{ top:2px; }
.plate-header .ur-badge{ top:0; }
.right-axis{ position:fixed; right:10px; top:100px; width:160px; max-height:70vh; overflow:auto; background:#fff; border:1px solid #eee; border-radius:4px; padding:6px; }
.axis-item{ display:flex; align-items:center; justify-content:space-between; padding:4px 6px; cursor:pointer; }
.axis-item:hover{ background:#f7f7f7; }
.dot{ width:8px; height:8px; border-radius:50%; background:#bbb; margin-right:6px; display:inline-block; }
.axis-name{ flex:1; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; margin-left:4px; }
.axis-count{ color:#999; margin-left:8px; }
.axis-item.active{ background:#fff3cd; }
.axis-item.active .dot{ background:#ffae00; }

@media (max-width: 480px){
  .ur-badge{ font-size:10px; height:16px; line-height:16px; padding:0 4px; top:1px; }
  .right-axis{ display:none; }
  
  .mobile-nav-bar {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    padding: 8px 4px;
    background: #fff;
  }
  .mobile-nav-item {
    display: inline-block;
    padding: 4px 12px;
    margin: 0 4px;
    border-radius: 16px;
    background: #f1f1f1;
    font-size: 13px;
    color: #666;
  }
  .mobile-nav-item.active {
    background: #007bff;
    color: #fff;
  }
  
  /* Helper classes for mobile table */
  .scale-8 {
    transform: scale(0.85);
    transform-origin: left center;
    display: inline-block;
  }
  
  .text-truncate-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
  }

  .mobile-stock-row:active {
    background-color: #f8f9fa;
  }
  
  .stock-market-tag {
    font-size: 10px;
    padding: 0 3px;
    border: 1px solid #dc3545;
    color: #dc3545;
    border-radius: 3px;
    margin-left: 4px;
    line-height: 12px;
    display: inline-block;
    vertical-align: 1px;
    font-weight: normal;
  }
  
  .first-board-badge {
    color: #999 !important;
    border-color: #ccc !important;
  }
  
  /* Remove border from the last row in card view if needed, but border-bottom is on wrapper */
}

</style>
